import { Tag } from 'antd'
import moment from 'moment-timezone'
import { Text } from '@signifyd/components'
import { statusTag } from 'utils/utils'
import { ColumnType } from 'antd/lib/table'
import { SpecForRun } from './useGetSpecsForRun'

export const allRunsColumns: Array<ColumnType<SpecForRun>> = [
  {
    title: 'Run ID',
    dataIndex: 'runId',
    key: 'runId',
    render: (runId: string) => <Text>{runId}</Text>,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    filters: [
      { text: 'Passed', value: 'passed' },
      { text: 'Failed', value: 'failed' },
      { text: 'Skipped', value: 'skipped' },
      { text: 'Flaky', value: 'flaky' },
      { text: 'Timed Out', value: 'timedOut' },
      { text: 'Interrupted', value: 'interrupted' },
    ],
    onFilter: (value, record) => record.status === value,
    render: (status: 'passed' | 'failed' | 'skipped') => (
      <Tag icon={statusTag[status]?.icon} color={statusTag[status]?.color}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </Tag>
    ),
  },
  {
    title: 'Duration',
    dataIndex: 'totalDuration',
    key: 'duration',
    sorter: (a, b) => {
      if (!a || !b) {
        return 0
      }

      return a.totalDuration - b.totalDuration
    },
    render: (duration: number) =>
      `${moment
        .duration(duration, 'milliseconds')
        .asSeconds()
        .toFixed(2)} seconds`,
  },
  {
    title: 'Timestamp',
    dataIndex: 'datetime',
    key: 'datetime',
    render: (datetime: string) =>
      moment(datetime).format('YYYY-MM-DD HH:mm:ss'),
    sorter: (a, b) => {
      if (!a.datetime || !b.datetime) {
        return 0
      }

      return new Date(a.datetime).getTime() - new Date(b.datetime).getTime()
    },
    defaultSortOrder: 'descend',
    sortDirections: ['ascend', 'descend', 'ascend'],
  },
  {
    title: 'Filename',
    dataIndex: 'fileName',
    key: 'filename',
    hidden: true,
  },
]
